<style lang="less" scoped>
.transferList {
  width: 100%;
  min-height: 100%;
  background: #ffffff;
  .roof {
    width: 100%;
    height: 100px;
    line-height: 100px;
    text-align: left;
    padding-left: 20px;
    box-sizing: border-box;
    background-color: #21aaff;
    font-size: 30px;
    color: #fff;
    display: flex;
    align-items: center;
    svg {
      margin-right: 20px;
    }
  }
  .baoguo {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    padding-top: 100px;
    .tupian {
      width: 525px;
      height: 437px;
      margin: 0 auto;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .nextStep {
      width: 582px;
      height: 74px;
      line-height: 74px;
      margin: 0 auto;
      margin-top: 100px;
      text-align: center;
      background: rgba(33, 170, 255, 1);
      border-radius: 50px;
      font-size: 36px;
      font-family: MicrosoftYaHei;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
    }
  }
}
</style>

<template>
  <div class="transferList">
    <div class="roof" @click="back">
      <svg
        t="1591005918644"
        class="icon"
        viewBox="0 0 1024 1024"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        p-id="1100"
        width="20"
        height="20"
      >
        <path d="M511.609097 961.619254" p-id="1101" fill="#ffffff"></path>
        <path
          d="M360.749204 511.010463 360.749204 511.010463l382.080022-382.074905c14.762215-14.788821 14.762215-38.777165 0-53.585429-14.812357-14.788821-38.799678-14.788821-53.607942 0L283.415908 481.201553c-1.107217 0.867764-2.190899 1.824555-3.206018 2.843768-14.788821 14.808264-14.788821 38.795585 0 53.585429l408.226518 408.230612c14.808264 14.807241 38.795585 14.807241 53.584406 0 14.785751-14.767332 14.785751-38.754652 0-53.562916L360.749204 511.010463 360.749204 511.010463zM360.749204 511.010463"
          p-id="1102"
          fill="#ffffff"
        ></path></svg
      >认证成功
    </div>
    <div class="baoguo">
      <div class="tupian">
        <img
          src="https://gsb-zc.oss-cn-beijing.aliyuncs.com//zc_20211614505618144202128174658144renzhengchenggong.png"
          alt=""
        />
      </div>
      <div class="nextStep" @click="nextStep">确定</div>
    </div>
  </div>
</template>

<script>
import http from "../../api/index.js";
import config from "../../utils/config.js";

export default {
  data() {
    return {};
  },
  mounted() {},
  methods: {
     back(){
        this.$router.go(-1);//返回上一层
    },
    nextStep() {
      const url = "/";
      this.$router.push({ path: url });
    },
  },

  components: {},
};
</script>


// WEBPACK FOOTER //
// src/pages/transferList/index.vue